module.exports = __webpack_public_path__ + "static/media/3.8d9c85ed.jpg";